import { TrackingParameters } from "./tracking-parameter";

export class Prospectregister {
    constructor (
        public FirstName: string = '',
        public LastName: string = '',
        public Email: string = '',
        public Password: string = '',
        public ConfirmPassword: string = '',
        public CellPhone: string = '',
        public PrimaryPOI: string = '',
        public MarketingSource: string = null,
        public Campaign: string = null,
        public AdGroup: string = null,
        public Keyword: string = null,
        public AdCopy: string = null,
        public Device: string = null,
        public Medium: string = null
    ) { }

    LoadFromLocalTourQueryParams()
    {
        let paramsString = localStorage.getItem('TrackingParameters');

        if (paramsString)
        {
            let params: TrackingParameters = JSON.parse(paramsString);
            this.MarketingSource = params.Source;
            this.Campaign = params.Campaign;
            this.AdGroup = params.AdGroup;
            this.Keyword = params.Keyword;
            this.AdCopy = params.AdCopy;
            this.Device = params.Device;
            this.Medium = params.Medium;
        }
    }
}
